// ==================================
// 読み込み
// ==================================

// import Splide JS
import Splide from "@splidejs/splide";

// 拡張機能
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export default function initSlider() {
  // ==================================
  // トップ メインビジュアルスライダー
  // ==================================
  function _initHmHeroSlider() {
    const hmHeroSlider = document.querySelector(".js-home-hero-slider");
    if (!hmHeroSlider) return;

    // スライド枚数をカウント
    const slideCount = hmHeroSlider.querySelectorAll(".splide__slide").length;

    // 1枚かどうかを判定
    const isStatic = slideCount <= 1;

    const slider = new Splide(hmHeroSlider, {
      autoplay: !isStatic,
      arrows: false,
      pagination: !isStatic,
      drag: !isStatic,
      pauseOnHover: false,
      pauseOnFocus: false,
      type: "fade",
      rewind: true,
      interval: 5000,
      speed: 2000,
      focus: "center",
      perPage: 1,
      updateOnMove: true,
    });

    slider.mount();
  }

  _initHmHeroSlider();

  // ==================================
  // トップ ギャラリースライダー
  // ==================================
  function _initHomeGallerySlider() {
    const homeGallerySlider = document.querySelector(".js-home-gallery-slider");

    if (!homeGallerySlider) return;

    Slider = new Splide(".js-home-gallery-slider", {
      type: "loop",
      focus: "center",
      arrows: false,
      pagination: false,
      perPage: 4,
      fixedWidth: 348,
      gap: "16px",

      autoScroll: {
        speed: 0.8,
        pauseOnHover: false,
        pauseOnFocus: false,
      },

      breakpoints: {
        1024: {
          perPage: 3,
        },

        768: {
          perPage: 1.5,
          fixedWidth: 256,
          gap: "30px",

          autoScroll: {
            speed: 0.5,
          },
        },
      },
    });

    Slider.mount({ AutoScroll });
  }
  _initHomeGallerySlider();

  // ==================================
  // スライダー
  // ==================================
  function _initSlider() {
    const Sliders = document.querySelectorAll(".js-slider");
    if (Sliders.length === 0) return;

    Sliders.forEach((Slider) => {
      // スライド枚数をカウント
      const slideCount = Slider.querySelectorAll(".splide__slide").length;

      // 1枚かどうかを判定
      const isStatic = slideCount <= 1;

      const slider = new Splide(Slider, {
        autoplay: !isStatic,
        arrows: !isStatic,
        pagination: !isStatic,
        rewind: !isStatic,
        drag: !isStatic,
        pauseOnHover: false,
        pauseOnFocus: false,
        type: isStatic ? "slide" : "loop",
        interval: 4000,
        speed: 500,
        focus: "center",
        padding: "20%",
        gap: 32,
        perPage: 1,
        updateOnMove: true,

        // --- レスポンシブ設定 ---
        breakpoints: {
          // 768px以下 (設定の調整のみ)
          768: {
            padding: "0",
            gap: 16,
            arrows: false,
          },
        },
      });

      slider.mount();
    });
  }

  _initSlider();
}
